module.exports = __webpack_public_path__ + "static/img/版头设计-插画类版头.c0d9763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/版头设计-插画类版头.png
// module id = gycE
// module chunks = 1